// extracted by mini-css-extract-plugin
export default {"container":"vqfZm7 mz-header-bar__title","supportedPlatforms":"A3D9Ll","downloadIcon":"Y_5GJF"};